const rootService = "https://www.cotelco.org:8443";

export const Services = {

  imagesBanner: `${rootService}/JSih/webresources/CPTurREST/getImagesPortal`,


  /** Indicators */

  indicatorsNacional: `${rootService}/JSih/webresources/CPTurREST/getNationalIndicators/`,

  /** posts */

  posts: `${rootService}/JSih/webresources/CPTurREST/getPublicationsCptur/`,

  /** staff */

  staffs: `${rootService}/JSih/webresources/CPTurREST/getFunctionariesCptur/`,

  /** departaments */

  departaments: `${rootService}/JSih/webresources/UtilityREST/getDepartaments`,
  years: `${rootService}/JSih/webresources/CPTurREST/getICTRCYears`,
  indicatorDepartament: `${rootService}/JSih/webresources/CPTurREST/getDepartmentIndicator`,
  indicatoDepartamentDetails: `${rootService}/JSih/webresources/CPTurREST/getComparatorOfIndicators`,

  /* capitals */
  capitals: `${rootService}/JSih/webresources/CPTurREST/getICTRCCapitalByDeptos`,
  yearsCapitls: `${rootService}/JSih/webresources/CPTurREST/getICTRCCapitalYears`,
  indicatorCapital: `${rootService}/JSih/webresources/CPTurREST/getCapitalIndicator`,
  indicatoCapitalDetails: `${rootService}/JSih/webresources/CPTurREST/getCapitalComparatorOfIndicators`,


  /** municipalities */
  yearsMunicipalities: `${rootService}/JSih/webresources/CPTurREST/getICTRCMunicipalityYears`,

  departamentsMunicipalities: `${rootService}/JSih/webresources/CPTurREST/getICTRCMunicipalityByDeptos`,
  municipalities: `${rootService}/JSih/webresources/CPTurREST/getICTRCMunicipality`,
  indicatorMunicipality: `${rootService}/JSih/webresources/CPTurREST/getMunicipalityIndicator`,


  indicatorMunicipalityDetails: `${rootService}/JSih/webresources/CPTurREST/getMunicipalityComparatorOfIndicators`,

  /** publications */

  publications: `${rootService}/JSih/webresources/CPTurREST/getPublicationsCptur/`,
  post: `${rootService}/JSih/webresources/CPTurREST/getCPublicationByToken`,

  /** libraries */

  documents: `${rootService}/JSih/webresources/CPTurREST/getDocumentsCptur`,
  documentsCategories: `${rootService}/JSih/webresources/GeneralDocumentsREST/getCategoriesDocs`,
  searchDocument: `${rootService}/JSih/webresources/CPTurREST/searchDocsCptur`,

  /** news */


  news: `${rootService}/JSih/webresources/CPTurREST/getNewsCptur`,
  new: `${rootService}/JSih/webresources/CPTurREST/getCNewsByToken`,
  relatedNews: `${rootService}/JSih/webresources/CPTurREST/getRelatedNewsCptur`,

  agnoskoj: `${rootService}/JSih/webresources/CPTurREST/getRecognitions`,

  types: `${rootService}/JSih/webresources/SuggestionREST/getSuggestionsTypes`,


  /*Practices*/

  goodPractices: `${rootService}/JSih/webresources/CPTurREST/getGoodPractices`,
  goodPractice: `${rootService}/JSih/webresources/CPTurREST/getGoodPractice`,

}

